/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Container, Row } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";
import {brand, brandtitle} from "config"

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <ul className="nav">
            <li className="nav-item">
              <a className="nav-link" href={`https://${brand}.com/`}>
                {`${brandtitle}`}
              </a>
            </li>{" "}
            <li className="nav-item">
              <a
                className="nav-link"
                  href={`https://${brand}.com/`}
              >
                About us
              </a>
            </li>{" "}
          </ul>
          <div className="copyright">
            © {new Date().getFullYear()} made by{" "}

            <a href={`https://${brand}.com/`} target="_blank">
              {`${brandtitle}`}
            </a>{" "}

          </div>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;
